import sharedStyles from 'styles/css/SharedStyles.module.scss';
import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';
import apiRequest from 'utils/apiRequest';

const DoctorVisitRates = () => {

    

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtn />
                

                <p className={[formStyles['text-center'], ruleStyles['font-weight-800'], formStyles['!text-primary'], formStyles.title].join(' ')}>
                    نرخ ویزیت پزشکان در سال ۱۴۰۴
                </p>

                <p className={[ruleStyles['text-justify']].join(' ')}>
                    طبق مصوبه هیئت محترم دولت، تعرفه خدمات ویزیت پزشکان در سال ۱۴۰۴ به شرح زیر اعلام می‌گردد:
                </p>
                <ul>
                    <li>پزشک عمومی (سطح یک): ۲۳۰٬۰۰۰ تومان</li>
                    <li>پزشک متخصص (سطح دو): ۳۲۰٬۰۰۰ تومان</li>
                    <li>پزشک فوق‌تخصص (سطح سه): ۳۸۵٬۰۰۰ تومان</li>
                </ul>

            </div>
                
        </div>

    );
}

export default DoctorVisitRates;